(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["homepage-tracking"] && !Shopify.designMode) return;
  try {
    (() => {
  const main = document.querySelector('[data-homepage-tracking]');
  if (!main || window.Shopify?.designMode || window.HerringHomepageTracking) return;
  window.HerringHomepageTracking = true;
  const measurementId = 'G-6N4NTCCSK2';
  const sections = Array.from(main.children).filter(node => node.classList.contains('shopify-section'));
  const viewed = new Set();
  const engaged = new Set();
  const timers = new Map();
  const pending = [];
  let retry;
  let googleConfigured = false;
  const clean = value => (value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
  const metadata = new Map(sections.map((section, index) => {
    const heading = section.querySelector('h1, h2, .ttl, .newsletter-heading');
    const content = section.querySelector('section, [class]');
    const type = Array.from(content?.classList || []).find(name => !['wrap', 'section'].includes(name)) || 'section';
    return [section, {
      section_id: section.id.replace(/^shopify-section-/, ''),
      section_name: clean(heading?.textContent) || type,
      section_position: index + 1
    }];
  }));

  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }

  function discardPending() {
    pending.forEach(({event, section}) => {
      if (event === 'homepage_section_view') viewed.delete(section);
      if (event === 'homepage_section_engaged') engaged.delete(section);
    });
    pending.length = 0;
  }

  function flush() {
    clearTimeout(retry);
    retry = undefined;
    if (!allowed()) { discardPending(); return; }
    if (document.hidden || !pending.length) return;
    googleConfigured = googleConfigured || (Array.isArray(window.dataLayer) &&
      window.dataLayer.some(entry => entry?.[0] === 'config' && entry[1] === measurementId));
    if (googleConfigured && typeof window.gtag === 'function') {
      while (pending.length && allowed()) {
        const item = pending[0];
        try { window.gtag('event', item.event, item.parameters); }
        catch (_) { break; }
        pending.shift();
      }
    }
    if (pending.length) retry = setTimeout(flush, 500);
  }

  function send(event, section, extra = {}) {
    if (!allowed() || document.hidden || pending.length >= 100) return false;
    const themeRole = window.Shopify?.theme?.role || 'unknown';
    pending.push({event, section, parameters: {
      send_to: measurementId,
      ...metadata.get(section),
      theme_role: themeRole,
      ...(themeRole !== 'main' ? {debug_mode: true} : {}),
      ...extra
    }});
    flush();
    return true;
  }

  function view(section) {
    if (!viewed.has(section) && send('homepage_section_view', section)) viewed.add(section);
  }

  function visible(section) {
    const rect = section.getBoundingClientRect();
    const height = Math.max(0, Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0));
    const width = Math.max(0, Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0));
    return rect.height > 0 && rect.width > 0 &&
      height >= Math.min(rect.height, window.innerHeight) * 0.5 &&
      width >= Math.min(rect.width, window.innerWidth) * 0.5;
  }

  function scan() {
    flush();
    sections.forEach(section => {
      const qualifies = allowed() && !document.hidden && visible(section);
      if (!qualifies || viewed.has(section)) {
        clearTimeout(timers.get(section));
        timers.delete(section);
      } else if (!timers.has(section)) {
        timers.set(section, setTimeout(() => {
          timers.delete(section);
          if (visible(section)) view(section);
        }, 1000));
      }
    });
  }

  let scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; scan(); });
  }

  main.addEventListener('click', event => {
    const control = event.target.closest?.('a[href], button, summary, input[type="submit"]');
    const section = control?.closest('.shopify-section');
    if (!metadata.has(section) || !allowed() || document.hidden || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    let path = '';
    let kind = control.matches('a') ? 'link' : 'control';
    if (control.matches('a')) {
      try {
        const url = new URL(control.getAttribute('href'), window.location.href);
        if (['http:', 'https:'].includes(url.protocol)) path = url.pathname.slice(0, 100);
        else if (url.protocol === 'tel:') kind = 'phone';
        else if (url.protocol === 'mailto:') kind = 'email';
      } catch (_) {}
    }
    view(section);
    const label = kind === 'phone' ? 'Phone' : kind === 'email' ? 'Email' :
      clean(control.getAttribute('aria-label') || control.textContent || control.querySelector('img')?.alt);
    const details = {
      interaction_type: kind,
      link_path: path,
      link_text: label,
      link_position: Array.from(section.querySelectorAll('a[href], button, summary, input[type="submit"]')).indexOf(control) + 1
    };
    send('homepage_section_click', section, details);
    if (!engaged.has(section) && send('homepage_section_engaged', section, details)) engaged.add(section);
  }, {capture: true});

  window.addEventListener('scroll', scheduleScan, {passive: true});
  window.addEventListener('resize', scheduleScan, {passive: true});
  window.addEventListener('pageshow', scan);
  document.addEventListener('visibilitychange', scan);
  document.addEventListener('visitorConsentCollected', scan);
  if (window.ResizeObserver) new ResizeObserver(scheduleScan).observe(main);
  scan();
  if (window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => {
      if (!error) scan();
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trust-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.querySelector('[data-trust-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const title = dialog.querySelector('[data-trust-dialog-title]');
  const status = dialog.querySelector('[data-trust-dialog-status]');
  const content = dialog.querySelector('[data-trust-dialog-content]');
  const full = dialog.querySelector('[data-trust-dialog-full]');
  let controller;
  let opener;
  let requestId = 0;

  dialog.querySelector('[data-trust-dialog-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    requestId++;
    if (controller) controller.abort();
    content.replaceChildren();
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });

  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-product-trust] a[data-trust-link]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.hasAttribute('download') || link.target === '_blank') return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol)) return;
    event.preventDefault();
    if (controller) controller.abort();
    controller = new AbortController();
    const activeController = controller;
    const current = ++requestId;
    opener = link;
    title.textContent = link.textContent.replace(/\s*→\s*$/, '').trim();
    full.href = url.href;
    content.replaceChildren();
    status.hidden = false;
    status.textContent = status.dataset.loading;
    dialog.showModal();
    dialog.querySelector('.trust-dialog__body').scrollTop = 0;
    const timeout = window.setTimeout(() => activeController.abort(), 12000);
    try {
      const response = await fetch(url.href, { signal: activeController.signal, credentials: 'same-origin' });
      if (!response.ok || new URL(response.url).origin !== window.location.origin) throw new Error('Page unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const main = page.querySelector('#main-content');
      const body = main && (main.querySelector('.article-body') || main);
      if (!body || !body.textContent.trim()) throw new Error('No page content');
      const heading = main.querySelector('h1');
      if (current !== requestId) return;
      if (heading) title.textContent = heading.textContent;
      body.querySelectorAll('script, style, link, iframe, object, embed, form, input, button, textarea, select, dialog, base, meta').forEach(node => node.remove());
      body.querySelectorAll('*').forEach(node => {
        Array.from(node.attributes).forEach(attribute => {
          if (/^on/i.test(attribute.name) || ['srcdoc', 'autofocus', 'id', 'style'].includes(attribute.name)) node.removeAttribute(attribute.name);
        });
        ['href', 'src', 'poster', 'xlink:href'].forEach(attribute => {
          const value = node.getAttribute(attribute);
          if (!value) return;
          try {
            const resolved = new URL(value, response.url);
            if (!['http:', 'https:', 'mailto:', 'tel:'].includes(resolved.protocol)) {
              if (node.tagName === 'A' && attribute === 'href') node.setAttribute('href', response.url);
              else node.removeAttribute(attribute);
            }
            else node.setAttribute(attribute, resolved.href);
          } catch (_) { node.removeAttribute(attribute); }
        });
        if (node.tagName === 'A' && /^https?:/.test(node.getAttribute('href') || '')) {
          node.target = '_blank';
          node.rel = 'noopener';
        }
      });
      if (!body.textContent.trim()) throw new Error('No readable content');
      content.replaceChildren(...body.childNodes);
      status.hidden = true;
    } catch (_) {
      if (current === requestId && dialog.open) status.textContent = status.dataset.error;
    } finally {
      window.clearTimeout(timeout);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trust-visibility"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.HerringTrustVisibility) return;
  const visitedKey = 'herring:trust:visited:v1';
  const sessionKey = 'herring:trust:session:v1';
  const paidKey = 'herring:trust:paid:v1';
  let firstVisit = null;
  let paidSearch = false;
  let hadPreferences = false;
  let hadMarketing = false;
  const editor = Boolean(window.Shopify && window.Shopify.designMode);
  const landingMedium = new URLSearchParams(window.location.search).get('utm_medium') || '';
  const paidLanding = ['cpc', 'ppc', 'paidsearch', 'paid_search', 'paid-search'].includes(landingMedium.toLowerCase());

  function apply() {
    document.querySelectorAll('[data-product-trust]').forEach(element => {
      const mode = element.dataset.trustVisibility || 'first_visit';
      element.hidden = !editor && mode !== 'everyone' &&
        (mode === 'first_visit_paid_search' ? !(firstVisit === true && paidSearch) : firstVisit === false);
    });
  }

  function clear(storage, key) {
    try { window[storage].removeItem(key); } catch (_) {}
  }

  function refresh() {
    if (editor) { apply(); return; }
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    let preferences = false;
    let marketing = false;
    try {
      preferences = Boolean(privacy && privacy.preferencesProcessingAllowed());
      marketing = Boolean(privacy && privacy.marketingAllowed());
    } catch (_) {}
    if (!preferences) {
      if (hadPreferences) {
        clear('localStorage', visitedKey);
        clear('sessionStorage', sessionKey);
      }
      firstVisit = null;
    } else if (firstVisit === null) {
      try {
        const saved = window.sessionStorage.getItem(sessionKey);
        const first = saved === 'first' || (saved !== 'returning' && window.localStorage.getItem(visitedKey) !== '1');
        window.sessionStorage.setItem(sessionKey, first ? 'first' : 'returning');
        window.localStorage.setItem(visitedKey, '1');
        firstVisit = first;
      } catch (_) {
        firstVisit = null;
      }
    }
    if (preferences && marketing) {
      try {
        paidSearch = window.sessionStorage.getItem(paidKey) === '1' || paidLanding;
        window.sessionStorage.setItem(paidKey, paidSearch ? '1' : '0');
      } catch (_) { paidSearch = paidLanding; }
    } else {
      if (hadMarketing) clear('sessionStorage', paidKey);
      paidSearch = false;
    }
    hadPreferences = preferences;
    hadMarketing = preferences && marketing;
    apply();
  }

  window.HerringTrustVisibility = { refresh };
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('pageshow', refresh);
  refresh();
  if (!editor && window.Shopify && !window.Shopify.customerPrivacy && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
      if (!error) refresh();
    });
  }
})();
  } catch(e) { console.error(e); }
})();

})();
